export const Navigate = (href: string) => {
  window.location.href = href;
};
